export const validationSchema = {
    email: {
        type: 'isEmail',
        message: 'Please enter a valid email.',
    },
};
